module.exports = __webpack_public_path__ + "img/xinissh.b2535ea2.png";